import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/assets/styles/main.css";
import 'mosha-vue-toastify/dist/style.css';
// import Vue3Tour from 'vue3-tour'
// import { AVPlugin } from 'vue-audio-visual'


const app = createApp(App)

app.use(store).use(router).mount('#app')


